import { PumoModuleFragment } from '../../generated/types';
import { useSwitchAmexModules } from './useSwitchAmexModules';
import { useSwitchClubModaModules } from './useSwitchClubModaModules';

export const useProcessModules = (modules: PumoModuleFragment[]) => {
  modules = useSwitchClubModaModules(modules);
  modules = useSwitchAmexModules(modules);
  return modules;
};
